<template>
  <div>
    <v-app>
      <v-content>
        <v-card>
          <Navbar v-scroll="onScroll" />
          <v-content>
            <section class="mx-auto" fixed-tabs>
              <v-img v-if="isbgDesktop" :src="require('../../assets/img/navbarbottom.jpg')" fixed-tabs class="white--text">
                <v-container fill-height>
                  <v-row class="mx-auto text-left mb-5">
                    <v-col cols="12" md="12">
                      <div class="slide-right">
                        <h2>ข้อกำหนดการใช้บริการระบบเก็บเอกสารอิเล็กทรอนิกส์</h2>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-img>
            </section>
            <section class="mx-auto" fixed-tabs>
              <v-img v-if="isbgMobile" :src="require('../../assets/img/bgsizemobile.jpg')" fixed-tabs class="white--text">
                <v-container fill-height>
                  <v-row class="mx-auto text-left mb-5">
                    <v-col cols="12" md="12">
                      <h2 class="animated fadeInUp ease-out-circ d2 a-1 f2 fw3">
                        ข้อกำหนดการใช้บริการ
                        <br />ระบบเก็บเอกสารอิเล็กทรอนิกส์
                      </h2>
                    </v-col>
                  </v-row>
                </v-container>
              </v-img>
            </section>
            <section class="white" style="color:#1A237E">
              <v-container>
                <v-row no-gutters>
                  <v-col class="text-center pa-5" cols="12" md="12">
                    <v-container grid-list-xs>
                      <h2>บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)</h2>
                      <br />
                      <v-divider></v-divider>
                      <br />
                      <div class="text-left mb-5">
                        <card-text color="white">
                          วัตถุประสงค์ของข้อกำหนดการใช้บัญชีที่ใช้สำหรับรับเอกสารอิเล็กทรอนิกส์ (ต่อไปนี้เรียกว่า “ข้อกำหนด”)
                          มีไว้เพื่อวางข้อกำหนดและเงื่อนไข
                          สำหรับการใช้บริการทั้งหมดที่เกี่ยวกับบัญชีที่ใช้สำหรับรับเอกสารอิเล็กทรอนิกส์ (ต่อไปนี้เรียกว่า
                          “บัญชีกลาง”) ซึ่งให้บริการโดยบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) และบริษัทในเครือ
                          (ต่อไปนี้เรียกรวมกันว่า “บริษัท”)
                          หากผู้ใช้งานต้องการใช้บัญชีกลางผู้ใช้งานจะต้องรับผิดชอบในการปฏิบัติตามกฎหมายและข้อบังคับทั้งหมดที่เกี่ยวข้องเมื่อใช้งาน
                          บัญชีกลางรวมถึงข้อกำหนดการใช้บริการ วัน ไอดี และนโยบายความเป็นส่วนตัว
                        </card-text>
                      </div>
                    </v-container>
                  </v-col>
                </v-row>
                <br />
              </v-container>
            </section>
            <section class="pt-8 pb-8">
              <v-container>
                <v-row justify="center">
                  <!-- <v-subheader>
                    <h2>ข้อมูลที่บริษัทต้องการนำไปใช้</h2>
                  </v-subheader> -->
                  <v-expansion-panels popout>
                    <v-expansion-panel class="mb-4" v-for="(message, i) in messages" :key="i" hide-actions>
                      <v-expansion-panel-header>
                        <v-layout row>
                          <v-flex x2 lg1 order-md1 order-xs1>
                            <v-avatar size="36px">
                              <v-icon :color="message.color" v-text="message.icon"></v-icon>
                            </v-avatar>
                          </v-flex>

                          <v-flex xs8 lg9 order-md2 order-xs2>
                            <strong v-html="message.title"></strong>
                          </v-flex>

                          <v-flex xs2 lg2 order-md3 order-xs3>
                            <v-chip
                              v-if="message.new"
                              :color="`${message.color} lighten-4`"
                              class="ml-0 mr-2 black--text"
                              label
                              small
                              >{{ message.new }}</v-chip
                            >
                          </v-flex>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-divider></v-divider>
                        <v-card-text :style="detail.class" v-for="detail in message.detail" :key="detail">{{
                          detail.sub
                        }}</v-card-text>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-container>
            </section>
          </v-content>
          <Footer />
        </v-card>
      </v-content>
    </v-app>
  </div>
</template>
<script>
import Navbar from "./layout-landingpage-navbar";
import Footer from "./layout-landingpage-footer";

export default {
  components: { Footer, Navbar },
  data: () => ({
    showDataOne: false,
    showDataTwo: false,
    showDataThree: false,
    showDataFour: false,
    showDataFive: false,
    showDataUsingOne: false,
    showDataUsingTwo: false,
    isbgDesktop: true,
    isbgMobile: false,
    messages: [
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 1  เนื้อหาของเว็บแอปพลิเคชัน",
        detail: [
          {
            sub:
              "1.1 ไม่ว่าผู้ใช้งานจะเป็นบุคคลธรรมดาหรือนิติบุคคล ผู้ใช้งานจะต้องทำการสมัครขอใช้งานบัญชีกลางผ่านทางวิธีการที่บริษัทกำหนด",
          },
          {
            sub:
              "1.2 เมื่อผู้ใช้งานได้สมัครใช้งานบัญชีกลางผ่านทางวิธีการที่บริษัทกำหนดและได้รับการอนุมัติจากบริษัทแล้ว ผู้ใช้งานจะได้รับพื้นที่เก็บข้อมูลที่เป็นส่วนตัวของผู้ใช้งาน ทางบริษัทจะไม่มีส่วนเกี่ยวข้องและเข้าไปยุ่งเกี่ยวกับข้อมูลในบัญชีกลางของผู้ใช้งาน",
          },
          {
            sub:
              "1.3 ทางบริษัทจะมีการส่งเอกสารอิเล็กทรอนิกส์ไปบัญชีกลางของผู้ใช้งาน ผู้ใช้งานจะต้องยินยอมให้บริษัทสามารถส่งเอกสารอิเล็กทรอนิกส์ไปยังบัญชีกลางและเอกสารอิเล็กทรอนิกส์จะถูกในเก็บไว้บัญชีวัน บ็อกซ์ของลูกค้า ทางบริษัทจะไม่มีส่วนเกี่ยวข้องและเข้าไปยุ่งเกี่ยวกับข้อมูลที่เก็บไว้ในบัญชีวัน บ็อกซ์ของลูกค้าเมื่อบริษัทได้ทำการส่งเอกสารอิเล็กทรอนิกส์ไปแล้ว",
          },
          {
            sub:
              "1.4 บริษัทจะอนุญาตให้อัปโหลด ดาวน์โหลด จัดเก็บ จัดส่ง รับไฟล์ในเก็บไว้บัญชีกลางของผู้ใช้งานได้โดยผู้ใช้งานเป็นเจ้าของเนื้อหาทั้งหมด",
          },
          {
            sub:
              "1.5 บริษัทไม่ต้องรับผิดชอบสำหรับความเสียหายหรือการเสียประโยชน์ที่เกิดขึ้นกับผู้ใช้งานจากการกระทำที่ได้กระทำผ่านบัญชีกลางไม่ว่าด้วยเหตุใดก็ตาม",
          },
          {
            sub:
              "1.6 ในกรณีที่สัญญาที่เกี่ยวกับการใช้งานบัญชีกลางถูกยกเลิกหรือเสร็จสมบูรณ์ หรือการให้การบริการบัญชีกลางเสร็จสมบูรณ์ บริษัทสามารถลบข้อมูลเกี่ยวกับบัญชีกลางที่เกี่ยวข้องและเนื้อหาที่มีการเผยแพร่ผ่านทางบัญชีกลาง (หมายถึง ข้อมูลหรือเนื้อหาในรูปแบบที่ผู้ใช้งานอนุญาตให้มีการส่งผ่านหรือเข้าถึงได้โดยผู้ใช้งานผ่านการใช้งานบัญชีกลาง รวมถึงแต่ไม่จำกัดเพียง ไอคอน ข้อมูลในโปรไฟล์ ข้อความ รูปภาพและภาพเคลื่อนไหวซึ่งส่งโดยผู้ใช้งาน ต่อไปนี้จะเรียกรวมกันว่า “เนื้อหา”) โดยดุลพินิจของบริษัท และผู้ใช้งานจะต้องให้ความยินยอมเพื่อการดำเนินการดังกล่าวด้วย",
          },
        ],
        // "1.1 ไม่ว่าผู้ใช้งานจะเป็นบุคคลธรรมดาหรือนิติบุคคล ผู้ใช้งานจะต้องทำการสมัครขอใช้งานบัญชีวัน บ็อกซ์ผ่านทางวิธีการที่บริษัทกำหนด\n"+
        // "1.2 เมื่อผู้ใช้งานได้สมัครใช้งานบัญชีวัน บ็อกซ์ผ่านทางวิธีการที่บริษัทกำหนดและได้รับการอนุมัติจากบริษัทแล้ว ผู้ใช้งานจะได้รับพื้นที่เก็บข้อมูลที่เป็นส่วนตัวของผู้ใช้งาน ทางบริษัทจะไม่มีส่วนเกี่ยวข้องและเข้าไปยุ่งเกี่ยวกับข้อมูลในวัน บ็อกซ์ของผู้ใช้งาน"+
        // "1.3 บริษัทจะอนุญาตให้อัปโหลด ดาวน์โหลด จัดเก็บ จัดส่ง รับไฟล์ในบัญชีวัน บ็อกซ์ของผู้ใช้งานได้โดยผู้ใช้งานเป็นเจ้าของเนื้อหาทั้งหมด"+
        // "1.4 บริษัทให้สิทธิผู้ใช้งานแชร์ไฟล์ให้กับผู้ใช้งานบัญชีวัน บ็อกซ์รายอื่นได้ เนื่องจากผู้ใช้งานเป็นเจ้าของเนื้อหา"+
        // "1.5 บริษัทไม่ต้องรับผิดชอบสำหรับความเสียหายหรือการเสียประโยชน์ที่เกิดขึ้นกับผู้ใช้งานจากการกระทำที่ได้กระทำผ่านบัญชีวัน บ็อกซ์ไม่ว่าด้วยเหตุใดก็ตาม"+
        // "1.6 ในกรณีที่สัญญาที่เกี่ยวกับการใช้งานบัญชีวัน บ็อกซ์ถูกยกเลิกหรือเสร็จสมบูรณ์ หรือการให้การบริการบัญชีวัน บ็อกซ์เสร็จสมบูรณ์ บริษัทสามารถลบข้อมูลเกี่ยวกับบัญชีวัน บ็อกซ์ที่เกี่ยวข้องและเนื้อหาที่มีการเผยแพร่ผ่านทางบัญชีวัน บ็อกซ์ (หมายถึง ข้อมูลหรือเนื้อหาในรูปแบบที่ผู้ใช้งานอนุญาตให้มีการส่งผ่านหรือเข้าถึงได้โดยผู้ใช้งานผ่านการใช้งานบัญชีวัน บ็อกซ์ รวมถึงแต่ไม่จำกัดเพียง ไอคอน ข้อมูลในโปรไฟล์ ข้อความ รูปภาพและภาพเคลื่อนไหวซึ่งส่งโดยผู้ใช้งาน ต่อไปนี้จะเรียกรวมกันว่า “เนื้อหา”) โดยดุลพินิจของบริษัท และผู้ใช้งานจะต้องให้ความยินยอมเพื่อการดำเนินการดังกล่าวด้วย"
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 2  ข้อมูลที่บริษัทต้องการนำไปใช้",
        detail: [
          {
            sub:
              "2.1 เมื่อท่านสร้างบัญชีกลาง เพื่อเข้าใช้บริการบัญชีวัน บ็อกซ์ บริษัทจะขอให้ท่านระบุหมายเลขโทรศัพท์ของท่าน ข้อมูลนี้เป็นข้อมูลที่จำเป็นเนื่องจากบริษัทอาจส่งข้อความผ่านเอสเอ็มเอสไปยังหมายเลขโทรศัพท์ที่ท่านระบุเพื่อตรวจจับและป้องกันอย่างต่อเนื่อง มิให้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ นอกจากนี้ บริษัทอาจใช้หมายเลขโทรศัพท์ที่ท่านลงทะเบียนนี้เพื่อส่งข้อมูลสำคัญเกี่ยวกับบริการให้แก่ผู้ใช้งานอีกด้วย",
          },
          {
            sub:
              "2.2 เมื่อท่านใช้บริการของบริษัท บริษัทอาจขอรับและเก็บรักษาข้อมูลแสดงตัวตนทางอิเล็กทรอนิกส์หรือบันทึกข้อมูลที่ได้มาโดยอัตโนมัติจากอุปกรณ์ของท่านบางรายการ อาทิเช่น ประเภทอุปกรณ์ ประเภทระบบปฏิบัติการ เลขที่อยู่ไอพี ข้อมูลเบราว์เซอร์ ข้อมูลคุกกี้ ตัวระบุโฆษณา หรือตัวระบุแอปพลิเคชันบนโทรศัพท์เคลื่อนที่ ข้อมูลนี้เป็นข้อมูลที่จำเป็นสำหรับบริษัทในการตรวจจับและป้องกันอย่างต่อเนื่องมิให้มีการใช้บริการโดยไม่ได้รับอนุญาต หรือใช้ในลักษณะฉ้อฉล หรือในทางมิชอบ ตลอดจนเพื่อให้บริการที่ผู้ใช้งานสามารถกำหนดเองได้และให้มีประสิทธิภาพมากที่สุดกับอุปกรณ์ของผู้ใช้งาน นอกจากนี้ ขอเรียนให้ทราบว่า ตัวระบุโฆษณาของบุคคลภายนอกอาจเชื่อมโยงกับบัญชีของผู้ใช้งานผ่านตัวระบุภายในของบริษัท",
          },
          {
            sub:
              "2.3 เพื่อวัตถุประสงค์ในการให้บริการแบบเฉพาะบุคคล (Personalized Services) ของบัญชีกลาง ท่านตกลงและยินยอมให้กลุ่มบริษัท เก็บรวบรวม ใช้งาน ประมวลผล และเปิดเผยข้อมูลต่างๆ ที่เกิดจากการใช้งานทั้งหมดจากบริการรับเอกสารอิเล็กทรอนิกส์และข้อมูลส่วนบุคคลของท่าน รวมถึงการเปิดเผยข้อมูลของท่านที่แต่ละบริษัทในกลุ่มบริษัทได้รับ ให้แก่บริษัทอื่น ๆ ในกลุ่มบริษัท ซึ่งสิทธิ หน้าที่ รายละเอียดการเก็บ ใช้ ประมวลผล เปิดเผยข้อมูล และความยินยอมในส่วนที่เกี่ยวกับข้อมูลส่วนบุคคลดังกล่าวจะเป็นไปตามที่ระบุในนโยบายการจัดการข้อมูลส่วนบุคคล ทั้งนี้ นโยบายการจัดการข้อมูลส่วนบุคคลถือเป็นส่วนหนึ่งของข้อตกลงและเงื่อนไขการใช้งานนี้",
          },
          {
            sub:
              "2.4 สำหรับข้อมูลที่เกิดจากการใช้งานในบัญชีกลาง หรือข้อมูลอื่นใดที่ท่านได้ให้ไว้แก่บริษัทซึ่งไม่ใช่ข้อมูลส่วนบุคคลท่านยินยอมให้บริษัทเปิดเผยข้อมูลต่อบริษัทในเครือของบริษัท พันธมิตรทางธุรกิจของบริษัท บุคคลภายนอกที่ร่วมมือกับบริษัทหรือให้บริการแก่บริษัท และหน่วยงานราชการที่เกี่ยวข้อง โดยการเก็บรวบรวม ใช้งาน ประมวลผล และ/เปิดเผยข้อมูลนั้นจะเป็นไป เพื่อวัตถุประสงค์ในการให้บริการและพัฒนาบริการรับเอกสารอิเล็กทรอนิกส์ให้ท่านได้รับประสบการณ์การบริการแบบเฉพาะบุคคล (Personalized Services) ที่ดีที่สุดในการใช้งาน เพื่อดำเนินกิจกรรมทางการตลาดและ/หรือประชาสัมพันธ์สินค้าและบริการต่าง ๆ ไม่ว่าจะเป็นสินค้าและบริการของบริษัทหรือของบุคคลอื่น เพื่อประมวลผลข้อมูลและวิเคราะห์พฤติกรรมการใช้บริการรับเอกสารอิเล็กทรอนิกส์เพื่อนำเสนอบริการแบบเฉพาะบุคคล (Personalized Services) ที่สอดคล้องกับความต้องการของท่าน และ/หรือเพื่อวัตถุประสงค์อื่น ๆ ที่บริษัทเห็นสมควร โดยบริษัทจะใช้ความพยายามอย่างดีที่สุดให้การใช้ข้อมูลเป็นไปตามวัตถุประสงค์ดังกล่าวและไม่ให้มีการเปิดเผยข้อมูลโดยมิชอบ",
          },
          {
            sub:
              "2.5 ในกรณีที่ท่านสมัครใช้งานระบบเอกสารอิเล็กทรอนิกส์จาก ระบบออกใบกำกับภาษีอิเล็กทรอนิกส์ของบริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) และบริษัทในเครือเพื่อความปลอดภัยในการใช้งานของท่าน ท่านตกลงและยินยอมให้แต่ละบริษัทในกลุ่มบริษัท เปิดเผยข้อมูลต่าง ๆ ที่เกิดจากการสมัครลงทะเบียนใช้งาน การใช้งานบริการรับเอกสารอิเล็กทรอนิกส์ทั้งหมด และข้อมูลส่วนบุคคลของท่าน ระหว่างกัน รวมถึงแต่ไม่จำกัดเพียง การปรับปรุงข้อมูลของท่านให้เป็นปัจจุบัน ตามที่ท่านได้ให้ไว้กับบริษัทใด จะมีผลให้ข้อมูลของท่านที่ได้ให้ไว้กับอีกบริษัทมีการแก้ไขปรับปรุงให้ตรงกัน ข้อมูลการยืนยันตัวตน และ PIN โดยการเก็บรวบรวม ใช้งาน และประมวลผล ข้อมูลดังกล่าวจะเป็นไปตามนโยบายการจัดการข้อมูลส่วนบุคคลที่เป็นส่วนหนึ่งของข้อตกลงและเงื่อนไขการใช้งานฉบับนี้",
          },
          {
            sub:
              "2.6 ท่านสามารถตัดสินใจว่าจะยินยอมให้บริษัทดำเนินการตามข้อกำหนดทั้งหมดข้างต้นหรือไม่ก็ได้ เพียงแต่การให้ข้อมูลที่ไม่ครบถ้วนตามที่บริษัทร้องขอหรือการไม่ให้ความยินยอมดังกล่าว อาจทำให้ท่านถูกจำกัดสิทธิการใช้บริการบางอย่างของบริการรับเอกสารอิเล็กทรอนิกส์ หรือส่งผลให้บริษัทไม่สามารถบริการรับเอกสารอิเล็กทรอนิกส์แก่ท่านได้",
          },
          {
            sub:
              "2.7 ท่านตกลงจะให้หรือทำให้ข้อมูลที่ให้แก่บริษัทเป็นข้อมูลที่ถูกต้อง ครบถ้วน และเป็นปัจจุบัน ในกรณีที่ท่านมีการเปลี่ยนแปลงข้อมูลสำคัญที่ท่านให้ไว้กับบริษัท เช่น การเปลี่ยนที่อยู่จดหมายอิเล็กทรอนิกส์ (e-mail) หรือหมายเลขโทรศัพท์ ท่านจะต้องแก้ไขข้อมูลทันทีบริการรับเอกสารอิเล็กทรอนิกส์ หรือวิธีการอื่นใดที่บริษัทแจ้งให้ท่านทราบ",
          },
          {
            sub:
              "2.8 ท่านตกลงและรับทราบว่าบริษัทมีสิทธิที่จะตรวจสอบการใช้บริการรับเอกสารอิเล็กทรอนิกส์ของท่านได้ ทั้งนี้ เพื่อให้เป็นไปตามกฎหมายที่เกี่ยวข้องและนโยบายภายในของบริษัท",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 3  การปรับปรุงข้อกำหนด",
        detail: [
          {
            sub:
              "บริษัทสามารถปรับปรุงข้อกำหนดนี้และลักษณะของการบริการ และอื่น ๆ ที่ให้บริการโดยบัญชีกลางได้โดยแจ้งให้ผู้ใช้งานทราบถึงการปรับปรุงดังกล่าวโดยการประกาศหรือการบอกกล่าวตามที่บริษัทเห็นว่าจำเป็นโดยดุลพินิจฝ่ายเดียวของบริษัทหรือตามที่กฎหมายที่เกี่ยวข้องกำหนด ในกรณีที่ผู้ใช้งานยังคงใช้งานบัญชีกลางต่อไปหลังจากการปรับปรุง ให้ถือว่าผู้ใช้งานดังกล่าวได้ให้ความยินยอมในการปรับปรุงข้อกำหนดนี้และลักษณะการบริการ และอื่น ๆ แล้ว",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 4  ระยะเวลาการใช้งาน",
        detail: [
          {
            sub:
              "ระยะเวลาใช้งานสำหรับบัญชีบัญชีกลางจะเริ่มต้นตั้งแต่วันที่ผู้ใช้งานมีคำขอใช้งานบัญชีดังกล่าวจนถึงวันที่บัญชีนั้นถูกลบอย่างเสร็จสมบูรณ์ โดยบริษัทจะเก็บรักษาข้อมูลที่ผู้ใช้งานจัดเก็บไว้บนบัญชีกลางของบริษัทตราบเท่าที่บัญชีของคุณยังคงอยู่ หรือตราบเท่าที่บริษัทต้องการข้อมูลเพื่อให้บริการแก่ผู้ใช้งาน หากผู้ใช้งานลบบัญชีของตนเองหรือถูกระงับการใช้งานบัญชี บริษัทจะเริ่มการลบข้อมูลนี้หลังจาก 14 วัน",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 5  ค่าบริการ",
        detail: [
          {
            sub:
              "5.1 บริษัทจะกำหนดลักษณะ ค่าบริการ และวันที่ถึงกำหนดชำระค่าบริการสำหรับแผนการบริการที่ต้องชำระค่าบริการ และอื่น ๆ และจะประกาศหรือบอกกล่าวผู้ใช้งานเกี่ยวกับเรื่องดังกล่าว โปรดตรวจสอบเรื่องดังกล่าวข้างต้นในเวลาที่สมัครใช้งานแผนการบริการที่ต้องชำระค่าบริการ",
          },
          {
            sub:
              "5.2 บริษัทสามารถเปลี่ยนแปลงหรือเพิ่มเติม แผนการบริการที่ต้องชำระค่าบริการโดยแจ้งให้ผู้ใช้งานทราบโดยการประกาศหรือบอกกล่าวเกี่ยวกับเรื่องดังกล่าว",
          },
          {
            sub:
              "5.3 เมื่อผู้ใช้งานประสงค์จะเปลี่ยนแปลงแผนการบริการจากแบบไม่มีค่าบริการเป็นแผนการบริการที่ต้องชำระค่าบริการ ผู้ใช้งานดังกล่าวจะต้องมีคำขอเปลี่ยนแปลงดังกล่าวผ่านทางวิธีการที่บริษัทกำหนดขึ้น และผู้ใช้งาน จะสามารถทำการเปลี่ยนแปลงดังกล่าวได้ในวันที่บริษัทได้รับคำขอเช่นว่านั้นแล้ว นอกจากนี้ เมื่อผู้ใช้งานประสงค์จะเปลี่ยนแปลงจากแผนการบริการที่ต้องชำระค่าบริการแผนหนึ่งเป็นอีกแผนหนึ่ง หรือเป็นแบบไม่มีค่าบริการ ผู้ใช้งานจะสามารถทำการเปลี่ยนแปลงดังกล่าวได้ในเดือนถัดจากวันที่บริษัทได้รับคำขอเปลี่ยนแปลงเช่นว่านั้น",
          },
          {
            sub:
              "5.4 แม้ว่าผู้ใช้งานจะได้ทำการยกเลิกบัญชีกลางสำหรับแผนการบริการที่ต้องชำระค่าบริการภายในเดือนใดแล้วก็ตาม ผู้ใช้งานดังกล่าวยังจะต้องชำระค่าบริการรายเดือนสำหรับเดือนดังกล่าวเต็มจำนวนและค่าบริการดังกล่าวจะไม่ถูกคำนวณเป็นรายวัน นอกจากนี้ แม้ว่าบัญชีจะถูกยกเลิกแล้ว บริษัทจะไม่คืนค่าบริการที่ผู้ใช้งานได้ชำระไว้ล่วงหน้าให้แก่ผู้ใช้งาน",
          },
          {
            sub:
              "5.5 ในเวลาที่ชำระค่าบริการให้แก่บริษัท หากค่าบริการดังกล่าวจะต้องเสียภาษีการบริโภคตามบทบัญญัติของพระราชบัญญัติภาษีธุรกิจว่าด้วยภาษีมูลค่าเพิ่มและที่ไม่ใช่ภาษีมูลค่าเพิ่ม (Value-added and Non-value-added Business Tax Act) รวมถึงกฎหมาย และ/หรือ ข้อบังคับที่เกี่ยวข้องกับพระราชบัญญัติดังกล่าว หรือกฎหมายหรือข้อบังคับใด ๆ ที่เกี่ยวข้อง ผู้ใช้งานจะต้องชำระค่าบริการนั้นพร้อมด้วยจำนวนเงินซึ่งเท่ากับภาษีที่เกี่ยวข้อง",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 6  ความรับผิดชอบของผู้ใช้งาน",
        detail: [
          {
            sub:
              "6.1 ในกรณีที่บุคคลที่สามได้มีการร้องเรียนหรือเรียกร้อง หรือยื่นฟ้องคดี และอื่น ๆ ต่อบริษัทเนื่องจากการใช้งานบัญชีกลางโดยผู้ใช้งาน ผู้ใช้งานจะต้องตอบสนองต่อเรื่องดังกล่าวด้วยค่าใช้จ่ายของตนเองและต้องรับผิดชอบแต่เพียงฝ่ายเดียว และผู้ใช้งานจะต้องไม่สร้างความยุ่งยากให้แก่บริษัทเกี่ยวกับเรื่องดังกล่าว ทั้งนี้ ผู้ใช้งานจะต้องรับผิดชอบต่อความรับผิดทางกฎหมายใด ๆ ที่เกิดขึ้นจากการใช้งานบัญชีกลางโดยผู้ใช้งาน ซึ่งผู้บริหารจัดการ (administrators) และบุคลากรผู้ดำเนินการบัญชีกลางจะต้องรับผิดร่วมกันและแทนกันในเรื่องดังกล่าวด้วย ทั้งนี้ ผู้ใช้งานตกลงว่าบริษัทจะไม่ต้องรับผิดชอบ ในความเสียหายหรือความรับผิดใด ๆ ที่เกิดขึ้นแก่บุคคลที่สามใด ๆ ซึ่งเกิดจากการใช้งานบัญชีกลาง",
          },
          {
            sub:
              "6.2 หากผู้ใช้งานละเมิดสิทธิใด ๆ หรือก่อให้เกิดความเสียหายใด ๆ แก่บุคคลที่สามโดยการฝ่าฝืนกฎหมายที่เกี่ยวข้องหรือละเมิดข้อกำหนดนี้ บริษัทสามารถ (1) จำกัดหรือห้ามผู้บริหารจัดการหรือบุคลากรผู้ดำเนินการบัญชีกลางดังกล่าว มิให้ดำเนินการบัญชีกลางอื่นใดที่มีอยู่อีกต่อไป และ (2) ปฏิเสธการขอใช้บริการบัญชีกลางโดยผู้บริหารจัดการหรือบุคลากรผู้ดำเนินการบัญชีกลางที่จะมีขึ้นใหม่ในอนาคตโดยไม่ต้องบอกกล่าวล่วงหน้าหรือชี้แจงเหตุผล",
          },
          {
            sub:
              "6.3 ผู้ใช้งานต้องชดใช้ความเสียหายใด ๆ (รวมถึง ค่าทนายความที่เกิดขึ้น) ต่อบริษัทซึ่งเกิดขึ้นจากการใช้งานบัญชีกลางโดยลูกค้าโดยทันที",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 7  การโอนและพันธมิตรทางธุรกิจ",
        detail: [
          {
            sub:
              "บริษัทสามารถให้ข้อมูลเกี่ยวกับบัญชีกลางแก่คู่ค้าทางธุรกิจและบุคคลที่สามอื่น ๆ (อย่างไรก็ตาม ไม่รวมถึงข้อมูลส่วนบุคคล) เกี่ยวกับผู้ใช้งานเพื่อจัดให้ซึ่งการทำงานของบัญชีกลางแก่คู่ค้าทางธุรกิจและเว็บไซต์ แอพพลิเคชั่น และอื่น ๆ เป็นต้น ของบุคคลที่สามอื่น ๆ ในการนี้ การเชื่อมโยงของผู้ใช้งานากับบัญชีกลางและอื่น ๆ อาจถูกแสดงอยู่บนเว็บไซต์ของคู่ค้าทางธุรกิจหรือบุคคลที่สามอื่น ๆ ก็ได้ ยิ่งไปกว่านั้น บริษัทสามารถแสดงตัวชี้แหล่งในอินเทอร์เน็ตของเว็บไซต์ (URL) ซึ่งรวมถึงข้อมูลของผู้ใช้งานไว้ที่หุ้นส่วนทางธุรกิจ เผยแพร่การเชื่อมต่อสู่เว็บไซต์ดังกล่าว เป็นต้น",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 8  การระงับ การเปลี่ยนแปลง และการเสร็จสมบูรณ์ของการบริการ",
        detail: [
          {
            sub:
              "8.1 ในกรณีของข้อใดข้อหนึ่งดังต่อไปนี้ บริษัทสามารถระงับการให้การบริการบัญชีกลางได้ในบางกรณี ถึงแม้ว่าบริษัทจะได้ระงับบัญชีกลางเป็นการชั่วคราว บริษัทจะไม่รับผิดชอบใด ๆ สำหรับการระงับดังกล่าวต่อผู้ใช้งาน",
          },
          {
            sub:
              "(1) ในกรณีของการบำรุงรักษา ตรวจสอบ หรือเรื่องอื่นในทำนองเดียวกัน เกี่ยวกับสิ่งอำนวยความหรืออุปกรณ์ที่จำเป็นสำหรับการให้การบริการบัญชีทางการ ซึ่งได้มีขึ้นตามปกติหรือในกรณีฉุกเฉิน",
            class: "padding-left:50px",
          },
          {
            sub:
              "(2) ในกรณีที่มีความล้มเหลว การหยุดทำงาน หรือเรื่องอื่นในทำนองเดียวกัน เกิดขึ้นกับสิ่งอำนวยความสะดวกหรืออุปกรณ์ที่ใช้ในการให้การบริการบัญชีกลาง",
            class: "padding-left:50px",
          },

          {
            sub: "(3) ในกรณีที่เป็นไปไม่ได้ที่จะใช้งานการบริการโทรคมนาคมซึ่งดำเนินการโดยผู้ประกอบธุรกิจโทรคมนาคม",
            class: "padding-left:50px",
          },
          {
            sub:
              "(4) ในกรณีที่มีความยุ่งยากในการให้การบริการบัญชีกลางเนื่องจากไฟดับ ไฟไหม้ แผ่นดินไหวการประท้วงของแรงงาน หรือเหตุสุดวิสัยในรูปแบบอื่น",
            class: "padding-left:50px",
          },
          {
            sub: "(5) ในกรณีที่มีสาเหตุเกี่ยวกับการดำเนินการหรือสาเหตุทางเทคนิคที่เกี่ยวข้องกับบัญชีกลางอย่างสมเหตุสมผล",
            class: "padding-left:50px",
          },
          {
            sub:
              "8.2 บริษัทสามารถเปลี่ยนแปลงหรือสิ้นสุดการดำเนินการบัญชีกลางทั้งหมดหรือบางส่วนได้โดยการประกาศหรือแจ้งให้ผู้ใช้งานทราบในเรื่องดังกล่าว แม้ว่าบริษัทจะได้เปลี่ยนแปลงหรือสิ้นสุดการดำเนินการบัญชีกลางแล้วไม่ว่าทั้งหมดหรือบางส่วน บริษัทจะไม่รับผิดชอบใด ๆ ในเรื่องดังกล่าวต่อผู้ใช้งานทั้งสิ้น",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 9   ความเสียหาย",
        detail: [
          {
            sub:
              "9.1 ในกรณีที่ผู้ใช้งานได้ละเมิดข้อกำหนดนี้และก่อให้เกิดความเสียหายแก่บริษัท (รวมถึงแต่ไม่จำกัดเพียง ค่าทนายความที่สมเหตุสมผล) ผู้ใช้งานจะต้องรับผิดชดใช้ความเสียหายนั้นให้แก่บริษัทโดยทันที",
          },
          {
            sub:
              "9.2 ในกรณีที่ผู้ใช้งานได้รับการการร้องเรียน การอ้างสิทธิ การร้องขอ การเรียกร้อง การคัดค้าน และอื่น ๆ เป็นต้น (ต่อไปนี้จะเรียกว่า “การร้องเรียน และอื่น ๆ”) จากบุคคลที่สาม เกี่ยวกับบัญชีกลาง โดยอ้างว่าสิทธิของบุคคลที่สามนั้นถูกละเมิด ผู้ใช้งานดังกล่าวจะต้องดำเนินการและแก้ไขการร้องเรียน และอื่น ๆ นั้นด้วยค่าใช้จ่ายและความรับผิดชอบของตน ทั้งนี้ ผู้ใช้งานต้องรับผิดชอบในความรับผิดทางกฎหมายใด ๆ ที่เกิดขึ้นจากการใช้งานบัญชีกลางโดยลูกค้าด้วยตนเอง และผู้ใช้งานตกลงว่าบริษัทจะไม่ต้องรับผิดสำหรับความเสียหายและการรับผิดใด ๆ ซึ่งเกิดขึ้นจากการใช้งานบัญชีกลางโดยผู้ใช้งานไม่ว่าในกรณีใดก็ตาม ซึ่งในกรณีที่มีความเสียหายเกิดขึ้นต่อบริษัทที่เกี่ยวข้องกับการร้องเรียน และอื่น ๆ ผู้ใช้งานจะต้องชดใช้ความเสียหายดังกล่าวทั้งหมดให้แก่บริษัท นอกจากนี้ ในกรณีที่บริษัทดำเนินการหรือแก้ไขการร้องเรียน และอื่น ๆ ดังกล่าวในนามของผู้ใช้งานที่เกี่ยวข้อง ผู้ใช้งานที่เกี่ยวข้องต้องรับผิดชอบค่าใช้จ่ายทั้งหมดสำหรับการดำเนินการและการแก้ไขนั้นด้วย",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 10  การระงับการใช้และการบอกเลิก",
        detail: [
          {
            sub:
              "ในกรณีที่บริษัทเห็นว่าข้อใดข้อหนึ่งดังต่อไปนี้เกิดขึ้นกับลูกค้าหรืออาจจะเกิดขึ้นกับผู้ใช้งาน บริษัทสามารถระงับบัญชีกลาง โดยการระงับการใช้งานบัญชีกลางโดยลูกค้าเป็นการชั่วคราว หรือบอกเลิกสัญญาต่าง ๆ (ต่อไปนี้จะเรียกว่า “สัญญา”) กับลูกค้าภายใต้ข้อกำหนดนี้ โดยไม่จำเป็นต้องแจ้งให้ทราบแต่อย่างใด และหากมีความเสียหายเกิดขึ้นแก่ผู้ใช้งานจากการระงับการใช้งานหรือการบอกเลิกสัญญาดังกล่าว บริษัทจะไม่รับผิดชอบใด ๆ ในเรื่องดังกล่าวแก่ผู้ใช้งานนั้น",
          },
          {
            sub: "(1)  ในกรณีที่ผู้ใช้งานได้ใช้บัญชีทางการสำหรับวัตถุประสงค์ที่ไม่ชอบด้วยกฎหมาย",
            class: "padding-left:50px",
          },
          {
            sub: "(2)  ในกรณีที่บริษัทเชื่อว่ามีการขาดความน่าเชื่อถือของผู้ใช้งาน",
            class: "padding-left:50px",
          },
          {
            sub: "(3)  ในกรณีที่ไม่สามารถติดต่อผู้ใช้งานได้ด้วยสาเหตุที่ไม่ใช่ความผิดของบริษัท",
            class: "padding-left:50px",
          },
          {
            sub: "(4)  ในกรณีที่ผู้ใช้งานไม่เข้าสู่บัญชีกลางของตนภายในระยะเวลาหนึ่งที่กำหนดขึ้นโดยบริษัท",
            class: "padding-left:50px",
          },
          {
            sub: "(5)  นอกเหนือจากกรณีที่ได้ระบุไว้ข้างต้น ในกรณีที่ผู้ใช้งานได้ดำเนินการที่บริษัทเห็นว่าไม่เหมาะสม",
            class: "padding-left:50px",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 11 การยกเลิก",
        detail: [
          {
            sub:
              "ข้อกำหนดการใช้บริการรับเอกสารอิเล็กทรอนิกส์จะมีผลต่อเนื่องนอกเสียจากผู้ใช้งานจะยกเลิกการยอบรับข้อข้อกำหนดการใช้บริการรับเอกสารอิเล็กทรอนิกส์ข้างต้นที่กล่าวมา การยกเลิกจะมีผลทันทีที่ผู้ใช้งานยืนยันการยกเลิก เมื่อยกเลิกข้อกำหนด ผู้ใช้งานยังสามารถเข้าใช้งานบัญชีกลางได้ แต่จะไม่สามารถรับเอกสารอิเล็กทรอนิกส์ผ่านทางบัญชีกลาง",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 12 การรักษาข้อมูลความลับ",
        detail: [
          {
            sub:
              "ทั้งสองฝ่ายตกลงที่จะดูแลรักษาข้อมูลความลับของอีกฝ่ายเพื่อให้เป็นความลับต่อไป จะไม่เปิดเผยข้อมูลความลับหรือยินยอมให้บุคคลอื่นรับทราบ หรือใช้ข้อมูลความลับ โดยจะใช้มาตรฐานการดูแลข้อมูลความลับนั้นเสมือนกับการดูแลรักษาข้อมูลความลับที่สุดของตนเองเป็นอย่างน้อย เว้นแต่ จะได้รับความยินยอมเป็นลายลักษณ์อักษรจากอีกฝ่ายหนึ่ง และ/หรือ เป็นการขอข้อมูลตามที่กฎหมายกำหนด",
          },
        ],
      },
      {
        color: "teal",
        icon: "mdi-progress-check",
        new: "อ่านเพิ่มเติม",
        title: "ข้อ 13 สิทธิในทรัพย์สินทางปัญญา",
        detail: [
          {
            sub:
              "ผู้ใช้งานยังคงความเป็นเจ้าของสิทธิ์ในทรัพย์สินทางปัญญาใด ๆ ที่ผู้ใช้งานถือสิทธิ์ในเนื้อหานั้น ๆ บริษัทจะไม่อ้างกรรมสิทธิ์ในเนื้อหาใด ๆ ของผู้ใช้งาน ซึ่งรวมถึงข้อความ ข้อมูล และไฟล์ที่ผู้ใช้งานอัปโหลด แชร์ หรือเก็บไว้ในบัญชีกลาง อย่างไรก็ตามเนื้อหาในบริการอาจได้รับการคุ้มครองโดยสิทธิ์ในทรัพย์สินทางปัญญาของผู้อื่น หากผู้ใช้งานไม่มีสิทธิ์ในการกระทำดังกล่าว โปรดอย่าคัดลอก อัปโหลด ดาวน์โหลด หรือแบ่งปันเนื้อหา บริษัทสงวนสิทธิ์ในการลบหรือหยุดใช้งานเนื้อหาที่ถูกกล่าวหาว่าละเมิดและยุติบัญชีของผู้ที่ละเมิดอยู่ต่อเนื่อง ตัวแทนที่ได้รับมอบหมายของเราสำหรับประกาศการละเมิดลิขสิทธิ์ที่ถูกกล่าวหาบนบริการ",
          },
        ],
      },
    ],
  }),
  methods: {
    onScroll() {
      const showsize = window.innerWidth;
      this.isbgDesktop = showsize > 600;
      this.isbgMobile = showsize < 600;
    },
  },
};
</script>
<style>
@import "../../assets/css/data.css";
</style>
